import { render, staticRenderFns } from "./kpi-table.vue?vue&type=template&id=2a412fba&scoped=true"
import script from "./kpi-table.vue?vue&type=script&lang=js"
export * from "./kpi-table.vue?vue&type=script&lang=js"
import style0 from "./kpi-table.vue?vue&type=style&index=0&id=2a412fba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a412fba",
  null
  
)

export default component.exports